const CategoryDropdownL2 = ({ selectHandler, elValue}) => {
    const L2List =  ["Catalan (Central)", "Spanish (Castilian)", "Italian", "Greek", "Norwegian", "English"];
  
    return <select value={elValue} 
        name="l2" 
        id="l2" 
        className="h-12 border-4 border-teal-400 rounded-md p-2 text-xl" 
        onChange={selectHandler}
    >
        {L2List.map(les => <option value={les} key={les}>
            {les}
        </option>)}
    </select>
};

export default CategoryDropdownL2;
